import * as Blockly from 'blockly/core';
import { stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['func_return'] = function (block: Blockly.Block): string {
        if (!block.isEnabled()) return '';
        const value = gen.valueToCode(block, 'VALUE', 0) || '0';
        return stmt(`return ${value}`);
    };
}
